<template lang="pug">
  .CreditAlert
    v-alert.py-2.mt-2(:color="credit>0 ? 'info400' : 'warning300'"  prominent style="width:100%")  
      v-row.align-center
        v-col.grow
          div(:class="credit > 0 ? 'basic100--text' : 'primary500--text'")
            div(:class="titleFont || 's1'") {{ $t('credit_balance') }}: {{credit | displayPrice}}
            div.primary500--text(v-if="showTitle && credit == 0" :class="descFont || 'c1'") {{ $t('reload_now_to') }} {{ title ? title : $t('send_out_reminders') }}
        v-col.shrink
          template(v-if="buttonSize")
            v-btn(outlined :class="buttonSize" :color="credit > 0 ? 'basic100' : 'primary500'" @click="openReload") {{ $t('reload') }}
          v-btn(v-else outlined :color="credit > 0 ? 'basic100' : 'primary500'" x-small height="26" style="background-color:var(--v-basic600T08)" @click="openReload") 
            .button-AA-tiny(:class="credit > 0 ? 'basic100--text' : 'primary500--text'") {{ $t('reload') }}
    .modals
      credit-reload(v-if="showCreditReloadDialog" :open.sync="showCreditReloadDialog" :refreshPage="!showTitle")
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import CreditReload from '@/components/yezzabook/dialogs/CreditReload.vue'

export default {
  name: 'CreditAlert',
  components:{CreditReload},
  props: ['credit', 'title', 'showTitle', 'titleFont', 'descFont', 'buttonSize'],
  data: () => ({
    showCreditReloadDialog: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    }
  },
  mounted () {
    this.$wamp.subscribe(`company:${this.company.id}:prepaid_credits`, (args, kwArgs) => {
      const company = { ...this.company}
      company.prepaid_credits = kwArgs.prepaid_credits
      this.updateCompany(company)
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
    })
  },
  methods:{
    ...mapActions([
      'updateCompany'
    ]),
    openReload() {
      this.showCreditReloadDialog = true
    }
  }
}
</script>

<i18n>
{
  "en": {
    "credit_balance": "Credit balance",
    "reload_now_to": "Reload now to",
    "send_out_reminders": "send out reminders"
  },
  "id": {
    "credit_balance": "Saldo kredit",
    "reload_now_to": "Muat lagi sekarang untuk",
    "send_out_reminders": "dapat mengirim pengingat"
  }
}
</i18n>